import { render, staticRenderFns } from "./MenuBuilder.vue?vue&type=template&id=2841f1a1&"
import script from "./MenuBuilder.vue?vue&type=script&lang=js&"
export * from "./MenuBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2841f1a1')) {
      api.createRecord('2841f1a1', component.options)
    } else {
      api.reload('2841f1a1', component.options)
    }
    module.hot.accept("./MenuBuilder.vue?vue&type=template&id=2841f1a1&", function () {
      api.rerender('2841f1a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/MenuBuilder.vue"
export default component.exports